import { FireOutbreak } from '../../../../@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import { FireOutbreakOccurrenceEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireOutbreakOccurence.enum'
import i18n from '@/VueI18n'

export class FireOutbreakAlertWhatsappMessageFactory {
	static make(fireOutbreak: FireOutbreak) {
		const t = (key: string) => i18n.t(key) as string
		const place =
			fireOutbreak.occurrence === FireOutbreakOccurrenceEnum.BUFFER
				? t('fireRiskDashboardWhatsappInBuffer')
				: t('fireRiskDashboardWhatsappInFarm')

		return `
🔥 *${t('fireRiskDashboardWhatsappTitle')}* 🔥

⚠️ ${t('fireRiskDashboardWhatsappOccurrence')} *${place}* ⚠️

🧮 ${t('fireRiskDashboardDetectionConfidence')}: *${fireOutbreak.detectionConfidenceLabel}*

🏡 *${t('fireRiskDashboardFarm')}:* ${fireOutbreak.farm}

⏰ *${t('fireRiskDashboardWhatsappOccurrenceTimestamp')}:* ${fireOutbreak.detectedAtLabel}

🌎 *${t('fireRiskDashboardWhatsappLocation')}:*

${t('fireRiskDashboardLatitude')}: ${fireOutbreak.latitude}

${t('fireRiskDashboardLongitude')}: ${fireOutbreak.longitude}
    `
	}
}
